import * as Sentry from "@sentry/react-router";
import { useEffect } from "react";

interface SentryUserConfig {
	userId: string | undefined;
}

/**
 * Hook to set the Sentry user context for error tracking.
 * When a userId is provided, errors will be associated with that user,
 * enabling the "Users Impacted" metric in Sentry dashboards.
 *
 * @param userId - Hashed user identifier (for privacy). Pass undefined to clear user context.
 */
export function useSentryUser({ userId }: SentryUserConfig): void {
	useEffect(() => {
		if (userId) {
			Sentry.setUser({ id: userId });
		} else {
			Sentry.setUser(null);
		}
	}, [userId]);
}
